import React from 'react';

const Notruf = () => (
  <div>
    <h3>Notruf abgeben</h3>
    <div style={{ padding: '0 15px' }}>
      <p>
        Aufgrund einer zu ungenauen Standortermittlung, werden Ihr Standort und Geokoordinaten hier
        nicht abgebildet. Dies beeinträchtigt allerdings in keiner Weise die Notruffunktion der App.
        Sollten Sie in Not sein, so wählen Sie über die Buttons „Polizei“ oder „Feuerwehr“ die
        Notrufnummern und geben Ihren Standort an den Telefonisten weiter.
      </p>
    </div>
    <div className="NotrufButtons">
      <a className="NotrufButton NotrufButton--blue" href="tel:110" alt="Polizei anrufen">
        <img
          className="NotrufButton-icon"
          src="/images/notruf-button-polizei.png"
          width="100"
          alt="Notruf icon"
        />
        Polizei
      </a>
      <a className="NotrufButton NotrufButton--red" href="tel:112" alt="Feuerwehr anrufen">
        <img
          className="NotrufButton-icon"
          src="/images/notruf-button-feuerwehr.png"
          width="100"
          alt="Notruf icon"
        />
        Feuerwehr
      </a>
    </div>
  </div>
);

export default Notruf;



// WEBPACK FOOTER //
// ./src/js/routes/Notruf.js